// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `zxing-scanner {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0;
  left: 0px;
  right: 0;
  object-fit: contain;
  border-radius: 10px;
  overflow: hidden;
}

.text-camera {
  background-color: transparent;
}

.fit-content ion-item {
  color: white !important;
  --padding-start: 0px;
  text-align: center;
}
.fit-content ion-item ion-label {
  margin-left: 25px;
}

.title {
  font-family: var(--font-tusker);
  font-size: 26px;
}

.subtitle {
  font-size: 14px;
  padding: 10px;
  color: white;
  text-align: center;
}

ion-content {
  --background: transparent;
  background: transparent;
}

.center-block > ion-col {
  position: relative;
}
.center-block img {
  width: 100% !important;
  box-shadow: 0px 0px 700px 10px rgb(27, 45, 58);
  border-radius: 15px;
  transition: 0.3s linear;
}

ion-header {
  --background: transparent;
  background: transparent;
}
ion-header .toolbar-background {
  background: transparent;
}
ion-header ion-icon {
  color: white;
  margin-right: 10px;
}

.blur img {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 100;
  object-fit: cover;
}

.btn {
  z-index: 9999;
}

.text_description {
  --background: transparent !important;
  color: white;
  z-index: 999;
}
.text_description p {
  font-size: 26px;
  line-height: 38px;
  margin: 25px 0px 0px;
  font-weight: bold;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
}
.text_description .divider {
  height: 4px;
  width: 30%;
  margin: 10px auto;
  background: var(--ion-color-tertiary);
}

.footer {
  position: absolute;
  bottom: 20px;
  left: 0px;
  width: 100%;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.footer ion-button {
  width: 70%;
  font-size: 16px;
}
.footer .cancel {
  width: 70%;
  --background: transparent;
  border: 2px solid white;
  border-radius: 50px;
}
.footer .payment {
  width: 80%;
  border-top: 2px solid rgba(255, 255, 255, 0.2);
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  padding: 10px 0px;
  text-align: center;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer .payment ion-img {
  width: 80%;
}

.lang-block {
  width: 100%;
  margin: 20px 0px;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 145px;
  margin: 0 auto 20px;
}
.footer-lang div {
  width: 48%;
  border: 2px solid white;
  background-color: transparent;
  border-radius: 50px;
  padding: 5px 0px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
.footer-lang div span {
  text-transform: uppercase;
  font-size: 12px;
  color: white;
}
.footer-lang div ion-icon {
  opacity: 0.3;
}
.footer-lang div.selected {
  background-color: white;
}
.footer-lang div.selected ion-icon {
  opacity: 1;
}
.footer-lang div.selected span {
  opacity: 1;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/components/scan-qr-sanifair/scan-qr-sanifair.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAGE;EACE,uBAAA;EACA,oBAAA;EACA,kBAAA;AAAJ;AACI;EACE,iBAAA;AACN;;AAGA;EACE,+BAAA;EACA,eAAA;AAAF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AACF;;AACA;EACE,yBAAA;EACA,uBAAA;AAEF;;AAEE;EACE,kBAAA;AACJ;AACE;EACE,sBAAA;EAGA,8CAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EACE,yBAAA;EACA,uBAAA;AACF;AAAE;EACE,uBAAA;AAEJ;AAAE;EACE,YAAA;EACA,kBAAA;AAEJ;;AAGE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAAJ;;AAGA;EACE,aAAA;AAAF;;AAEA;EACE,oCAAA;EACA,YAAA;EACA,YAAA;AACF;AAAE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;AAEJ;AAAE;EACE,WAAA;EACA,UAAA;EACA,iBAAA;EACA,qCAAA;AAEJ;;AACA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAEF;AADE;EACE,UAAA;EACA,eAAA;AAGJ;AADE;EACE,UAAA;EAEA,yBAAA;EACA,uBAAA;EACA,mBAAA;AAEJ;AAAE;EACE,UAAA;EACA,8CAAA;EACA,iDAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAEJ;AADI;EACE,UAAA;AAGN;;AACA;EACE,WAAA;EACA,gBAAA;AAEF;;AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAGF;AADE;EACE,UAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAGJ;AADI;EACE,yBAAA;EAEA,eAAA;EACA,YAAA;AAEN;AACI;EACE,YAAA;AACN;AAII;EACE,uBAAA;AAFN;AAIM;EACE,UAAA;AAFR;AAKM;EACE,UAAA;EACA,YAAA;AAHR","sourcesContent":["zxing-scanner {\r\n  height: 100%;\r\n  width: 100%;\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0;\r\n  left: 0px;\r\n  right: 0;\r\n  object-fit: contain;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n.text-camera {\r\n  background-color: transparent;\r\n}\r\n\r\n.fit-content {\r\n  ion-item {\r\n    color: white !important;\r\n    --padding-start: 0px;\r\n    text-align: center;\r\n    ion-label {\r\n      margin-left: 25px;\r\n    }\r\n  }\r\n}\r\n.title {\r\n  font-family: var(--font-tusker);\r\n  font-size: 26px;\r\n}\r\n.subtitle {\r\n  font-size: 14px;\r\n  padding: 10px;\r\n  color: white;\r\n  text-align: center;\r\n}\r\nion-content {\r\n  --background: transparent;\r\n  background: transparent;\r\n}\r\n\r\n.center-block {\r\n  > ion-col {\r\n    position: relative;\r\n  }\r\n  img {\r\n    width: 100% !important;\r\n    -webkit-box-shadow: 0px 0px 700px 10px rgb(27, 45, 58);\r\n    -moz-box-shadow: 0px 0px 700px 10px rgb(27, 45, 58);\r\n    box-shadow: 0px 0px 700px 10px rgb(27, 45, 58);\r\n    border-radius: 15px;\r\n    transition: 0.3s linear;\r\n  }\r\n}\r\nion-header {\r\n  --background: transparent;\r\n  background: transparent;\r\n  .toolbar-background {\r\n    background: transparent;\r\n  }\r\n  ion-icon {\r\n    color: white;\r\n    margin-right: 10px;\r\n  }\r\n}\r\n\r\n.blur {\r\n  img {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 100;\r\n    object-fit: cover;\r\n  }\r\n}\r\n.btn {\r\n  z-index: 9999;\r\n}\r\n.text_description {\r\n  --background: transparent !important;\r\n  color: white;\r\n  z-index: 999;\r\n  p {\r\n    font-size: 26px;\r\n    line-height: 38px;\r\n    margin: 25px 0px 0px;\r\n    font-weight: bold;\r\n    font-family: AppFontBold, sans-serif;\r\n    text-transform: uppercase;\r\n  }\r\n  .divider {\r\n    height: 4px;\r\n    width: 30%;\r\n    margin: 10px auto;\r\n    background: var(--ion-color-tertiary);\r\n  }\r\n}\r\n.footer {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  left: 0px;\r\n  width: 100%;\r\n  z-index: 999;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  ion-button {\r\n    width: 70%;\r\n    font-size: 16px;\r\n  }\r\n  .cancel {\r\n    width: 70%;\r\n\r\n    --background: transparent;\r\n    border: 2px solid white;\r\n    border-radius: 50px;\r\n  }\r\n  .payment {\r\n    width: 80%;\r\n    border-top: 2px solid rgba(255, 255, 255, 0.2);\r\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\r\n    padding: 10px 0px;\r\n    text-align: center;\r\n    height: 55px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    ion-img {\r\n      width: 80%;\r\n    }\r\n  }\r\n}\r\n.lang-block {\r\n  width: 100%;\r\n  margin: 20px 0px;\r\n}\r\n.footer-lang {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  max-width: 145px;\r\n  margin: 0 auto 20px;\r\n\r\n  div {\r\n    width: 48%;\r\n    border: 2px solid white;\r\n    background-color: transparent;\r\n    border-radius: 50px;\r\n    padding: 5px 0px;\r\n    margin-right: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: white;\r\n\r\n    span {\r\n      text-transform: uppercase;\r\n      // opacity: 0.3;\r\n      font-size: 12px;\r\n      color: white;\r\n    }\r\n\r\n    ion-icon {\r\n      opacity: 0.3;\r\n    }\r\n  }\r\n\r\n  div {\r\n    &.selected {\r\n      background-color: white;\r\n\r\n      ion-icon {\r\n        opacity: 1;\r\n      }\r\n\r\n      span {\r\n        opacity: 1;\r\n        color: black;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
